{
  "host": "Хост",
  "user": "Пользователь",
  "password": "Пароль",
  "open": "Открыть консоль",
  "close": "Закрыть консоль",
  "modal": {
    "title": "Открыть консоль"
  }
}